export const LEGAL_PAGES = [
  {
    path: '/privacy-policy',
    title: 'Privacy Policy',
    eyebrow: 'Privacy and Data Use',
    subtitle:
      'This Privacy Policy explains how Thar Enterprises collects, uses, stores, and shares information submitted through this website.',
    lastUpdated: 'March 16, 2026',
    sections: [
      {
        heading: 'Information We Collect',
        paragraphs: [
          'We collect the information that you choose to submit through our contact form, service request forms, and payment flow. This may include your name, email address, mobile number, city, business details, tax details, bank details, uploaded supporting documents, and payment reference information.',
          'We may also receive limited technical information such as browser, device, and IP-related data through standard hosting and security logs.',
        ],
      },
      {
        heading: 'How We Use Your Information',
        paragraphs: [
          'We use your information to respond to enquiries, evaluate service requests, prepare documentation, coordinate filing or registration work, communicate updates, and maintain internal service records.',
          'If you make a payment through the website, the payment is processed through a third-party payment gateway and we use the payment confirmation details to complete your submission and reconcile your service request.',
        ],
      },
      {
        heading: 'Sharing of Information',
        paragraphs: [
          'We may share information with government departments, regulatory portals, document processing partners, payment gateway providers, email service providers, and other operational vendors only to the extent necessary to deliver the requested service or comply with legal obligations.',
          'We do not sell your personal information.',
        ],
      },
      {
        heading: 'Document Handling and Security',
        paragraphs: [
          'Uploaded files and submitted details are handled for service processing and internal review. We take reasonable administrative and technical measures to protect submitted information, but no internet transmission or storage system can be guaranteed as completely secure.',
        ],
      },
      {
        heading: 'Data Retention',
        paragraphs: [
          'We retain submitted information for as long as reasonably necessary to provide the requested service, maintain business records, resolve disputes, meet legal or compliance requirements, and support audit or follow-up obligations.',
        ],
      },
      {
        heading: 'Your Choices',
        paragraphs: [
          'You may contact us to request correction or deletion of information that you have submitted, subject to legal, regulatory, recordkeeping, and service-delivery requirements.',
        ],
      },
      {
        heading: 'Contact',
        paragraphs: [
          'For privacy-related requests, you can contact Thar Enterprises at tharenterprisespune@gmail.com or +91 96642 23533.',
        ],
      },
    ],
  },
  {
    path: '/disclaimer',
    title: 'Disclaimer',
    eyebrow: 'Website Disclaimer',
    subtitle:
      'This Disclaimer sets out the limitations of the information and services presented on the Thar Enterprises website.',
    lastUpdated: 'March 16, 2026',
    sections: [
      {
        heading: 'General Information Only',
        paragraphs: [
          'The content on this website is provided for general informational purposes only. It should not be treated as legal, tax, accounting, financial, regulatory, or professional advice for any specific matter.',
        ],
      },
      {
        heading: 'No Guarantee of Approval or Outcome',
        paragraphs: [
          'Submission of a form, payment of a service fee, or engagement with Thar Enterprises does not guarantee approval, registration, licence issuance, loan sanction, refund, or a specific processing timeline. Outcomes depend on the accuracy of information provided, document sufficiency, third-party review, and applicable government or institutional rules.',
        ],
      },
      {
        heading: 'User Responsibility',
        paragraphs: [
          'You are responsible for ensuring that all information, declarations, and uploaded documents submitted through this website are accurate, complete, lawful, and up to date.',
        ],
      },
      {
        heading: 'Third-Party Platforms and Payment Services',
        paragraphs: [
          'This website may rely on third-party tools and service providers, including payment gateways, email systems, hosting infrastructure, and government or regulatory portals. We are not responsible for downtime, delays, policy changes, or technical issues caused by third-party systems.',
        ],
      },
      {
        heading: 'Fees and Scope',
        paragraphs: [
          'Any service fee shown or collected through this website relates only to the scope described by Thar Enterprises unless expressly stated otherwise. Government fees, statutory charges, stamp duty, portal charges, professional add-ons, or third-party costs may apply separately.',
        ],
      },
      {
        heading: 'External Links and Content',
        paragraphs: [
          'If this website links to external websites or portals, those links are provided for convenience only. Thar Enterprises does not control and is not responsible for external content, privacy practices, accuracy, or availability.',
        ],
      },
      {
        heading: 'Contact',
        paragraphs: [
          'If you need clarification about a service shown on this website, please contact Thar Enterprises before making a submission or payment.',
        ],
      },
    ],
  },
];

export const getLegalPageByPath = (path) => {
  const normalizedPath = path.replace(/\/+$/, '') || '/';
  return LEGAL_PAGES.find((page) => page.path === normalizedPath) || null;
};
